import { FC } from 'react'
import Typography from '@mui/material/Typography'
import { Box, SxProps } from '@mui/material'
import { CustomIconFromValue } from './CustomIconFromValue'
import { TranslateMessage } from '@app/lib/lang'
import theme from '@app/lib/materialui/theme'

interface NoDataProps {
	icon?: string | null
	text?: string
	sx?: SxProps
}

export const NoData: FC<NoDataProps> = (props) => {
	const { icon = 'svg no-data', text = 'shared.noData' } = props

	return (
		<Box
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			height="100%"
			id="no-data"
			data-testid="no-data"
			sx={props.sx}
		>
			{icon && <CustomIconFromValue icon={icon} />}
			<Typography
				sx={{
					color: theme.palette.grey[400],
					marginTop: theme.spacing(2),
				}}
			>
				<TranslateMessage id={text} />
			</Typography>
		</Box>
	)
}
